import { DocumentTemplatesArchiveFileData } from "@interfaces/company/document-templates";
import { documentTemplateService } from "@services/document-templates-service";
import { useMutation, useQueryClient } from "react-query";
import { documentTemplatesQueryKeys } from "./queryKeys";

export const useUnarchiveDocumentTemplatesFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: DocumentTemplatesArchiveFileData) =>
      documentTemplateService.unarchiveFile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(documentTemplatesQueryKeys.all);
      },
    }
  );
};
